<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                <div 
                  class="body-2 mb-2">
                  Unit / Divisi
                </div>

                <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Kantor Pusat SDM"

                  hide-details

                  :items="unit"
                  item-text="name"
                  item-value="id"
                  :item-color="set_color"

                  clearable
                  @click:clear="filter.unit_id = ''; filter.unit_name = '';"

                  v-model="filter.unit_id"
                  :success="filter.unit_id !== ''"
                  class="mb-2"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="filter.unit_id !== ''">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="amanata"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Maping
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="7">
              <div
                class="d-flex align-center">
                <div>
                  <div
                    class="body-2">
                    <span>
                      Pegawai Presensi (Hari Ini):
                    </span>
                    
                    <strong class="black--text">{{ count.hadir }}</strong>
                  </div>
                </div>

                <div
                  class="ml-16">
                  <div
                    class="body-2">
                    <span>
                      Pegawai Ijin (Hari Ini):
                    </span>
                    
                    <strong class="black--text">{{ count.ijin }}</strong>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="5"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog.filter = true; fetchUnit();"
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-filter-multiple-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <gmap-map
                  ref="gmap"
                  :center="center"
                  :zoom="12"
                  :scrollwheel="false"
                  style="width:100%; height: calc(100vh - 248px);">

                  <gmap-marker
                    v-for="(item, index) in markers"
                    :key="index"
                    :position="item.latlng"
                    :icon="item.icon"
                    @click="toggleInfoWindow(item, index)">
                  </gmap-marker>

                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen = false">
                    <div v-html="infoContent"></div>
                  </gmap-info-window>
                </gmap-map>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import firebase from "firebase";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          filter: false
        },
        
        search: '',

        filter: {
          unit_id: '',
          unit_name: ''
        },

        selected: {
          all: []
        },

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },

        markers: [],
        unit: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        count: {
          hadir: 0,
          ijin: 0
        },

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    created() {
      let ref = firebase.firestore().collection('routes')
      ref.onSnapshot(snapshot => {
        this.fetchData()
      })
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchData()

        this.fetchHadir()

        this.fetchIjin()
      },
      async fetchData () {
        this.process.load = true
        
        let params = {
          limit: 100000,
          'date[eq]': moment().format('YYYY-MM-DD'),

          search: this.search
        }

        this.selected.all = []

        this.markers = []

        await get(`admin/attendance/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
            
            if (this.pagination.total_data > 0) {
              this.list.map((obj) => {
                this.selected.all.push(obj)
              })

              this.fetchCheck()
            } else {
              this.dialog.snackbar = this.search.length > 0 ? true : false
              this.message.success = this.search.length > 0 ? 'Data yang anda cari tidak ditemukan.' : ''
            }
          }
        })
      },

      async fetchCheck () {
        let data = this.selected.all

        for (let i = 0; i < data.length; i++) {
          let ref = firebase.firestore().collection('routes').where('user_id', '==', data[i].user_id)

          await ref.onSnapshot(snapshot => {
            if (snapshot.docChanges().length > 0) {
              if (snapshot.docChanges()[0].type === 'added') {
                let id = snapshot.docs.map((doc) => {
                  return doc.id
                })
                
                this.fetchRoute(id[0])
              } else {
                this.markers = []

                this.fetchData()
              }
            }
          })
        }
      },

      async fetchRoute (id) {
        let ref = firebase.firestore().collection('routes').doc(id).collection('user').orderBy('input_datetime', 'asc')

        await ref.onSnapshot(snapshot => {
          if (snapshot.docChanges().length > 0) {
            let data = snapshot.docs.map((doc) => {
              return {
                id: doc.data().id,
                code: doc.data().code,
                name: doc.data().name,
                username: doc.data().username,
                email: doc.data().email,
                mobilephone: doc.data().mobilephone,
                address: doc.data().address,
                image_url: doc.data().image_url,
                position: doc.data().position,
                role: doc.data().role,
                unit_id: doc.data().unit_id,
                unit_name: doc.data().unit_name,
                latitude: doc.data().latitude,
                longitude: doc.data().longitude,
                input_datetime: doc.data().input_datetime
              }
            })

            this.insertMarker(data)
          } else {
            this.markers = []
          }
        })
      },

      insertMarker (data) {
        this.$gmapApiPromiseLazy().then(() => {
          this.markers.push({
            id: data[data.length - 1].id,
            code: data[data.length - 1].code,
            name: data[data.length - 1].name,
            username: data[data.length - 1].username,
            email: data[data.length - 1].email,
            mobilephone: data[data.length - 1].mobilephone,
            address: data[data.length - 1].address,
            image_url: data[data.length - 1].image_url,
            position: data[data.length - 1].position,
            role: data[data.length - 1].role,
            unit_id: data[data.length - 1].unit_id,
            unit_name: data[data.length - 1].unit_name,
            latitude: data[data.length - 1].latitude,
            longitude: data[data.length - 1].longitude,
            input_datetime: data[data.length - 1].input_datetime,
            latlng: {
              lat: parseFloat(data[data.length - 1].latitude), 
              lng: parseFloat(data[data.length - 1].longitude)
            },
            icon: {
              url: require('@/assets/icon/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[this.markers.length - 1].latlng : this.center
        })
      },

      toggleInfoWindow (marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },

      getInfoWindowContent (marker) {
        let data = marker

        data.image_url = data.image_url !== '' ? data.image_url : require('@/assets/image/member_default.png')

        return (`
          <div id="iw-container">
            <div 
              class="iw-title"
              style="border-radius: 10px; font-weight: 600; font-size: 18px;">
              Lokasi Terakhir
            </div>

            <div 
              class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.image_url}">

              <div 
                class="iw-subTitle" 
                style="margin-bottom: 10px; line-height: 1.5 !important; color: #000000;">
                ${data.name}
              </div>

              <div 
                style="margin-bottom: 2px; opacity: 50%;">
                Email
              </div>

              <div 
                style="margin-bottom: 14px; font-weight: bold;">
                ${data.email}
              </div>

              <div 
                style="margin-bottom: 2px; opacity: 50%;">
                Telepon
              </div>

              <div 
                style="margin-bottom: 14px; font-weight: bold;">
                ${data.mobilephone}
              </div>

              <div 
                style="margin-bottom: 2px; opacity: 50%;">
                Unit
              </div>

              <div 
                style="margin-bottom: 14px; font-weight: bold; text-transform: capitalize;">
                ${data.unit_name}
              </div>

              <div 
                style="margin-bottom: 2px; opacity: 50%;">
                Role (Posisi)
              </div>

              <div 
                style="font-weight: bold; text-transform: capitalize;">
                ${data.role} (${data.position})
              </div>
            </div>
          </div>
        `)
      },

      async fetchHadir () {
        let params = {
          'date[eq]': moment().format('YYYY-MM-DD'),
          status: 'hadir',

          unit_id: this.filter.unit_id
        }

        await get(`admin/attendance/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.count.hadir = res.results.pagination.total_data
          }
        })
      },

      async fetchIjin () {
        let params = {
          'date[eq]': moment().format('YYYY-MM-DD'),
          status: 'ijin',

          unit_id: this.filter.unit_id
        }

        await get(`admin/attendance/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.count.ijin = res.results.pagination.total_data
          }
        })
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      }
    }
  }
</script>